angular.module("ainapp")
    .controller("VoucherLinksController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Voucher Links";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.switchTab = function (tab, type, voucher) {
                $scope.selectedVoucher = voucher;
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CostCenterSettings = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherLinksbyType(type).then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
            }


            $scope.Init = function () {

                $scope.ViewVal = 1;
                $scope.ViewValType = 'Material Request';
                $scope.selectedVoucher = 'Material Request';

                $scope.CostSetting = {
                    VoucherName: "",
                    LinkName: "",
                    IsEnable: true,
                    IsCustomerMap: true,
                    QcostMap: "QCost",
                    IsMultiple: false,
                }

                $scope.switchTab(1, 'Material Request', 'Material Request');

            }
            $scope.Init();



            $scope.refreshCostCenter = function () {

                $scope.CostSetting = {
                    VoucherName: $scope.ViewValType,
                    LinkName: "",
                    IsEnable: true,
                    IsCustomerMap: true,
                    QcostMap: "QCost",
                    IsMultiple: false,
                }


                $scope.switchTab($scope.ViewVal, $scope.ViewValType, $scope.selectedVoucher);

            }

            $scope.editCostCenter = function (data) {

                $scope.CostSetting = data;

            }

            $scope.saveCostSettings = function () {

                if ($scope.CostSetting.LinkName == "") {
                    toastr.error("Choose Voucher Link");
                } else {
                    $scope.CostSetting.VoucherName = $scope.ViewValType;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddVoucherLinks($scope.CostSetting).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType, $scope.selectedVoucher);
                            $scope.refreshCostCenter();
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }


            $scope.deleteSet = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteVocherLinking(data.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType, $scope.selectedVoucher);
                        $scope.refreshCostCenter();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }


            $scope.updateCostSettings = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddVoucherLinks(data).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType, $scope.selectedVoucher);
                        $scope.refreshCostCenter();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }




      }]);
